import { jsx as _jsx } from "react/jsx-runtime";
import { ICONS } from '@app/styles';
import './Component_UtilitiesMenu.scss';
import { PopUp_UtilitiesMenu } from '../../../pop-ups/PopUp_UtilitiesMenu/PopUp_UtilitiesMenu.js';
export const Component_UtilitiesMenu = () => {
    return _jsx(ICONS.more.component, { className: 'c__utilities-menu', onClick: PopUp_UtilitiesMenu.show });
};
//# sourceMappingURL=Component_UtilitiesMenu.js.map